<form
	#noteForm="ngForm"
	(ngSubmit)="createUpdate(noteForm)"
	class="flex flex-col min-h-0"
>
	<div class="flex gap-2 items-end">
		<app-input
			label="Title"
			[(ngModel)]="note.title"
			tooltip="Pin note"
			[required]="!note.description"
			[submitted]="submitted"
			name="title"
			[placeholder]="first50CharDescription"
		></app-input>
		<button
			class="flex items-center justify-center h-10 w-10 shrink-0 cursor-pointer border hover:text-amber-600 rounded-md duration-300"
			[ngClass]="{
				'border-amber-200 text-amber-600 bg-amber-50': note.pinned,
				'border-transparent hover:bg-gray-50': !note.pinned,
			}"
			(click)="
				togglePinned(); $event.stopPropagation(); $event.preventDefault()
			"
		>
			<i-tabler name="pin" class="w-5 h-5"></i-tabler>
		</button>
	</div>
	<div class="flex flex-1 mt-5 mb-4">
		<app-text-area
			rows="10"
			[allowResize]="false"
			label="Description"
			[(ngModel)]="note.description"
			[required]="!note.title"
			name="description"
			(debounce)="setFirst50CharDescription($event)"
		></app-text-area>
	</div>
	@if (id && note.createdAt) {
		<div class="flex justify-between flex-col 2xl:flex-row gap-1">
			<div class="flex gap-2">
				<p class="text-xs font-semibold">Created:</p>
				<div class="flex gap-2">
					<p class="text-xs">
						{{ note.createdAt | date: 'longDate' }} &middot;
						{{ note.createdAt | date: 'shortTime' }}
					</p>
					<div class="border-l border-gray-200"></div>
					<p class="text-xs">
						{{ note.creatorFirstName }}
						{{ note.creatorLastName }}
					</p>
				</div>
			</div>
			<div class="flex gap-1" *ngIf="note.updatedAt">
				<p class="text-xs font-semibold">Updated:</p>
				<div class="flex gap-2">
					<p class="text-xs">
						{{ note.updatedAt | date: 'longDate' }} &middot;
						{{ note.updatedAt | date: 'shortTime' }}
					</p>
					<div class="border-l border-gray-200"></div>
					<p class="text-xs">
						{{ note.lastUpdatedByFirstName }}
						{{ note.lastUpdatedByLastName }}
					</p>
				</div>
			</div>
		</div>
	}
	<div
		*ngIf="submitted && !note?.title && !note?.description"
		class="mt-3 flex text-center text-red"
	>
		Please provide a title or a description to save the note
	</div>
	<div class="flex justify-end mt-5 gap-2">
		<ui-button color="gray" (click)="close()" label="Cancel"></ui-button>
		<ui-button preset="HIGH_EMPHASIS" type="submit" label="Save"></ui-button>
	</div>
</form>
